import React, {useState, useEffect} from 'react'
import {useNavigate, useLocation, Navigate} from 'react-router-dom'
import {client} from '../utils/api-client'
import {useAsync} from '../utils/use-async'
import logo from '../assets/Thryv.png'
import {toast} from 'react-toastify'
import {Button, Input} from '@thryvlabs/maverick'
import {Spinner} from './custom/loader-spinner'
import whiteLettersLogo from '../assets/thryv-logo-white-letters.svg'

import '../styles/formScreensStyles.css'
import {useSelector} from 'react-redux'

export const ScreenContainer = ({children, className = '', ...props}) => (
  <div className={`screen-container ${className}`} {...props}>
    {children}
  </div>
)

export const Container = ({children, className = '', ...props}) => (
  <div className={`container ${className}`} {...props}>
    {children}
  </div>
)

export const BlueGradientBackground = ({
  showLogo = true,
  backgroundHexColor = '#fff',
  width = '100%',
  className = '',
}) => {
  return (
    <section
      className={`blue-gradient-bg ${className}`}
      style={{
        background: backgroundHexColor,
        width,
      }}
    >
      <div>
        {showLogo && (
          <img
            src={whiteLettersLogo}
            alt="Logo"
            style={{
              maxWidth: '98px',
              marginTop: '24px',
              marginLeft: '24px',
            }}
          />
        )}
      </div>
    </section>
  )
}

export const ThryvLogoBlackLetters = () => {
  return (
    <img
      src={logo}
      alt="Logo"
      style={{
        maxWidth: '98px',
        marginBottom: '12px',
      }}
    />
  )
}

const AuthForm = () => {
  const [method, setMethod] = useState('sms')
  const [smsValue, setSmsValue] = useState('')
  const [emailValue, setEmailValue] = useState('')
  const [linkValidityStatus, setLinkValidityStatus] = useState(false)
  const [isLoading, setLoadingStatus] = useState(false)
  const {isMobileViewEnable} = useSelector(state => {
    return state.screenView
  })

  const {run} = useAsync({
    status: 'pending',
  })
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const id = params.get('LinkId')

  useEffect(() => {
    console.log({id})
    async function checkLinkValidityStatus() {
      const response = await run(
        client(`keappartner/fetchKeapPartnerLinkStatus/${id}`),
      )
      setLoadingStatus(true)
      if (response.data.length > 0) {
        let isLinkStillActive = response.data.find(
          item => item.link_status === 'Pending',
        )
        if (isLinkStillActive) {
          setLinkValidityStatus(true)
        } else {
          toast.error(
            'The url link provided is either already used or expired, kindly connect with keap partner to generate new link.',
          )
        }
      } else {
        setLinkValidityStatus(true)
      }
    }
    if (id) {
      checkLinkValidityStatus()
    }
  }, [id])

  const defaultStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  }

  const checkedStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  }

  const optionStyle = {
    boxShadow:
      '0px 1px 3px 0px #00000033, 0px 2px 1px -1px #0000001F, 0px 1px 1px 0px #00000024',
    borderRadius: '10px',
    padding: '16px 20px',
    cursor: 'pointer',
    display: 'flex',
  }

  const labelStyle = {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '0px',
    margin: '0px',
  }

  console.log('params -', id)
  const apiUrl = 'keappartner/sendotp'
  const navigate = useNavigate()

  useEffect(() => {
    const getKeapActivityFuncTrigger = async () => {
      try {
        if (id) {
          let data = {
            linkId: id,
            currentScreen: 'home',
            baseUrl: window.location.href,
          }
          const response = await run(
            client('keappartner/updatePartnerActivity', {data, method: 'PUT'}),
          )

          if (response && response.error) {
            toast.error(response.error)
          }
        }
      } catch (err) {
        console.log(err)
        toast.error(JSON.stringify(err))
      }
    }
    getKeapActivityFuncTrigger()
  }, [])
  const validateEmail = email => {
    const regex = /^[a-zA-Z0-9._+-]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }
  const validatePhone = phone => {
    const regex = /^\+?[0-9]{10,15}$/ // Accepts an optional '+' at the beginning, followed by 10 to 15 digits
    return regex.test(phone)
  }

  const handleSubmit = async () => {
    let response
    if (method === 'sms') {
      if (!validatePhone(smsValue)) {
        toast.warn('Phone number is not correct')
      } else {
        let data = {
          keapPartnerRecordId: id || 4,
          method: 'sms',
          phoneNum: smsValue,
        }
        response = await run(client(apiUrl, {data, method: 'POST'}))
        toast.success(
          'One-time code has been sent. Please check your text messages. ',
        )
        navigate(`/verifytoken?LinkId=${id}`)
      }
    } else if (method === 'email') {
      if (validateEmail(emailValue)) {
        let data = {
          keapPartnerRecordId: id || 4,
          method: 'email',
          emailId: emailValue,
        }
        response = await run(client(apiUrl, {data, method: 'POST'}))
        toast.success('One-time code has been sent. Please check your email.')
        navigate(`/verifytoken?LinkId=${id}`)
      } else {
        toast.error('Please use valid email ID to send the OTP')
      }
    }

    console.log(response)
  }

  if (Array.from(params.keys()).length === 0) {
    return <Navigate to="/not-found" replace />
  }
  return !isLoading ? (
    <>
      <Spinner />
    </>
  ) : linkValidityStatus ? (
    <>
      <BlueGradientBackground />
      {isMobileViewEnable ? (
        <>
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100vh',
              zIndex: 1,
              overflow: 'hidden',
            }}
          >
            {/* write below code for mobile view */}
            <div
              style={{
                backgroundColor: 'white',
                margin: 'auto',
                border: '1px solid #ECEEF1',
                borderRadius: '12px',
                // maxWidth: '605px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                'box-shadow': '0px 2px 4px 0px #00000040',
                padding: '20px 0px',
                gap: '24px',
                width: '80%',
              }}
            >
              <section
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                <ThryvLogoBlackLetters />
                <p
                  style={{
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'black',
                    margin: '0px',
                    padding: '0px 20px',
                  }}
                  className="text-center"
                >
                  Thank you for choosing Thryv!
                </p>
                <p
                  style={{
                    fontFamily: 'Open Sans',
                    fontWeight: 600,
                    fontSize: '12px',
                    color: '#4D4D4D',
                    letterSpacing: 0,
                    // lineHeight: '20px',
                    margin: '0px',
                    // verticalAlign: 'Middle',
                    // whiteSpace: 'nowrap',
                    padding: '0px 20px',
                  }}
                  className="text-center"
                >
                  Help us to keep your data safe. To verify your identity, we
                  need to send you a one-time code. How would you like to
                  receive it? Message and data rates from your carrier may
                  apply.
                </p>
              </section>
              <section
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  width: '100%',
                  padding: '0px 20px',
                }}
              >
                <div
                  style={{
                    ...optionStyle,
                    ...(method === 'sms' ? checkedStyle : defaultStyle),
                    display: 'flex',
                    gap: '12px',
                  }}
                  onClick={() => setMethod('sms')}
                >
                  <div
                    className="flex"
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="radio"
                      id="sms"
                      name="sms"
                      value="sms"
                      checked={method === 'sms'}
                      onClick={() => setMethod('sms')}
                      className="radio-input"
                    />
                    <label
                      htmlFor="sms"
                      className="cursor-pointer"
                      style={labelStyle}
                    >
                      <span
                        style={{
                          marginLeft: '12px',
                        }}
                      >
                        Text Message
                      </span>
                    </label>
                  </div>
                  {method === 'sms' && (
                    <Input
                      variant="default"
                      type="text"
                      placeholder={'Phone number'}
                      style={{
                        marginLeft: '28px',
                      }}
                      value={smsValue}
                      onChange={e => setSmsValue(e.target.value)}
                    />
                  )}
                </div>
                <div
                  style={{
                    ...optionStyle,
                    ...(method === 'email' ? checkedStyle : defaultStyle),
                    display: 'flex',
                    gap: '12px',
                  }}
                  onClick={() => setMethod('email')}
                >
                  <div
                    className="flex"
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="radio"
                      id="email"
                      name="email"
                      value="email"
                      checked={method === 'email'}
                      onClick={() => setMethod('email')}
                      className="radio-input"
                    />
                    <label
                      htmlFor="email"
                      className="cursor-pointer"
                      style={labelStyle}
                    >
                      <span
                        style={{
                          marginLeft: '12px',
                        }}
                      >
                        Email
                      </span>
                    </label>
                  </div>
                  {method === 'email' && (
                    <div className="d-flex flex-column align-items-center">
                      <Input
                        variant="default"
                        type="text"
                        placeholder={'Email'}
                        value={emailValue}
                        style={{
                          marginLeft: '28px',
                        }}
                        onChange={e => setEmailValue(e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </section>
              <Button
                onClick={handleSubmit}
                variant="primary"
                style={{
                  fontFamily:
                    'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                  marginBottom: '6px',
                }}
              >
                Send
              </Button>
            </div>
          </section>
        </>
      ) : (
        <>
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100vh',
              zIndex: 1,
              overflow: 'hidden',
            }}
          >
            {/* write below code for mobile view */}
            <div
              style={{
                backgroundColor: 'white',
                margin: 'auto',
                border: '1px solid #ECEEF1',
                borderRadius: '12px',
                maxWidth: '605px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                'box-shadow': '0px 2px 4px 0px #00000040',
                padding: '50px 92.5px',
                gap: '24px',
              }}
            >
              <section
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                <ThryvLogoBlackLetters />
                <h2
                  style={{
                    fontFamily: 'Montserrat',
                    fontSize: '28px',
                    fontWeight: '600',
                    lineHeight: '36px',
                    color: 'black',
                    margin: '0px',
                    whiteSpace: 'nowrap',
                  }}
                  className="text-center"
                >
                  Thank you for choosing Thryv!
                </h2>
                <p
                  style={{
                    fontFamily: 'Open Sans',
                    fontWeight: 400,
                    fontSize: '14px',
                    color: '#4D4D4D',
                    letterSpacing: 0,
                    lineHeight: '20px',
                    margin: '0px',
                    verticalAlign: 'Middle',
                    whiteSpace: 'nowrap',
                  }}
                  className="text-center"
                >
                  Help us to keep your data safe. To verify your identity, we
                  need to
                  <br></br>
                  send you a one-time code. How would you like to receive it?
                  <br></br>
                  Message and data rates from your carrier may apply.
                </p>
              </section>
              <section
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    ...optionStyle,
                    ...(method === 'sms' ? checkedStyle : defaultStyle),
                    display: 'flex',
                    gap: '12px',
                  }}
                  onClick={() => setMethod('sms')}
                >
                  <div
                    className="flex"
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="radio"
                      id="sms"
                      name="sms"
                      value="sms"
                      checked={method === 'sms'}
                      onClick={() => setMethod('sms')}
                      className="radio-input"
                    />
                    <label
                      htmlFor="sms"
                      className="cursor-pointer"
                      style={labelStyle}
                    >
                      <span
                        style={{
                          marginLeft: '12px',
                        }}
                      >
                        Text Message
                      </span>
                    </label>
                  </div>
                  {method === 'sms' && (
                    <Input
                      variant="default"
                      type="text"
                      placeholder={'Phone number'}
                      style={{
                        marginLeft: '28px',
                      }}
                      value={smsValue}
                      onChange={e => setSmsValue(e.target.value)}
                    />
                  )}
                </div>
                <div
                  style={{
                    ...optionStyle,
                    ...(method === 'email' ? checkedStyle : defaultStyle),
                    display: 'flex',
                    gap: '12px',
                  }}
                  onClick={() => setMethod('email')}
                >
                  <div
                    className="flex"
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="radio"
                      id="email"
                      name="email"
                      value="email"
                      checked={method === 'email'}
                      onClick={() => setMethod('email')}
                      className="radio-input"
                    />
                    <label
                      htmlFor="email"
                      className="cursor-pointer"
                      style={labelStyle}
                    >
                      <span
                        style={{
                          marginLeft: '12px',
                        }}
                      >
                        Email
                      </span>
                    </label>
                  </div>
                  {method === 'email' && (
                    <div className="d-flex flex-column align-items-center">
                      <Input
                        variant="default"
                        type="text"
                        placeholder={'Email'}
                        value={emailValue}
                        style={{
                          marginLeft: '28px',
                        }}
                        onChange={e => setEmailValue(e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </section>
              <Button
                onClick={handleSubmit}
                variant="primary"
                style={{
                  fontFamily:
                    'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
                  marginBottom: '6px',
                }}
              >
                Send
              </Button>
            </div>
          </section>
        </>
      )}
    </>
  ) : (
    <ScreenContainer>
      <div
        className="d-flex justify-content-center w-100"
        style={{
          color: 'black',
          fontSize: '18px',
          fontWeight: 900,
          margin: 'auto',
        }}
      >
        <div>
          <span>{`The Link which you are trying is either got expired or inactive.`}</span>
          <br />
          <span>{`Kindly connect with Keap partner to generate new link.`}</span>
        </div>
      </div>
    </ScreenContainer>
  )
}

export default AuthForm
